// /records/<key>: a link to one record (alerts and emails use these). Shows the brief with the record open.
import { useEffect } from "react";
import { useParams } from "react-router";
import { useUI } from "../app/context";
import { Brief } from "./Brief";

export function RecordPage() {
  const { key = "" } = useParams();
  const { openPanel } = useUI();
  useEffect(() => {
    if (key) openPanel({ kind: "notice", key, feedId: null });
  }, [key, openPanel]);
  return <Brief />;
}
